import { company } from '../data/company';

// Shared contact targets so every Call / WhatsApp / Email button points at the same place.
const ownerPhone = company.phones.find((p) => p.label === 'Owner') || company.phones[0];

export const whatsappUrlFor = (phone) => `https://wa.me/${phone.international.replace(/\D/g, '')}`;

export const salesPhone = company.phones[0];
// Default WhatsApp target for single "WhatsApp us" buttons (unchanged: the owner's number)
export const whatsappUrl = whatsappUrlFor(ownerPhone);
export const emailHref = `mailto:${company.email}`;
export const quotePath = '/contact#contact-form';

// Google Maps turn-by-turn directions to the business (opens the Maps app on phones)
export const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
  `OJANNA Distributors (Pty) Ltd, ${company.address.street}, ${company.address.locality}`
)}`;

// Short opening-hours lines from company.openingHours, e.g. "Mon–Thu 07:30–16:15"
export const hoursLines = company.openingHours.map((h) => {
  const short = (d) => d.slice(0, 3);
  const days = h.days.length > 1 ? `${short(h.days[0])}–${short(h.days[h.days.length - 1])}` : short(h.days[0]);
  return `${days} ${h.opens}–${h.closes}`;
});

// Quote form pre-filled with a product category and item (see Contact.js)
export const quoteLinkFor = (categoryId, item) =>
  `/contact?product=${encodeURIComponent(categoryId)}&item=${encodeURIComponent(item)}#contact-form`;

// WhatsApp chat with a ready-to-send message
export const whatsappMessageUrl = (text) => `${whatsappUrl}?text=${encodeURIComponent(text)}`;
